export default {
  'form.rule.required': '这是必填项',
  'form.rule.max': '最大长度为 {max}',
  'form.rule.phone': '请输入正确的手机号',
};
